import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './locale/i18n';
import AppContainer from './modules/App/containers/AppContainer/AppContainer';
import {HashRouter} from 'react-router-dom';
import {unregister} from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';

import './stylesheets/Lato/latofonts.css';
import './stylesheets/semantic.min.css';
import './index.css'; // IMPORTANT: import index css AFTER semantic ui css
import 'react-datepicker/dist/react-datepicker.min.css';
import {initializeTracking} from "./modules/App/services/Analytics";

initializeTracking();

ReactDOM.render(
    <CookiesProvider>
        <HashRouter>
            <AppContainer />
        </HashRouter>
    </CookiesProvider>,
    document.getElementById('root') as HTMLElement
);

unregister();